<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Campo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <field-form @save="saveField"></field-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import FieldForm from './Forms/FieldForm';
import swal from 'sweetalert2';

export default {
  name: 'FieldsCreate',
  components: {
    RouteBreadCrumb,
    FieldForm,
  },

  data() {
    return {};
  },

  methods: {
    saveField(field) {
      this.$services
        .resource('fields')
        .create(field)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'El campo fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'FieldsList' }));
        });
    },
  },
};
</script>
